import React from 'react';
import StatsDisplayCustomer from '../../../topbars/StatsDisplayCustomer';

interface CustomerAnalyticsTabProps {
  customerId: number;
}

const CustomerAnalyticsTab: React.FC<CustomerAnalyticsTabProps> = ({ customerId }) => {
  return (
    <div>
      <StatsDisplayCustomer customerId={customerId} onTileSelect={() => {}} />
    </div>
  );
};

export default CustomerAnalyticsTab;
